export enum FeedbackQueryParams {
  SearchText = 'q',
  Size = 'size',
  Page = 'page',
  StarsAmount = 'starsAmount',
  StartDate = 'startDate',
  EndDate = 'endDate',
}
